// What the user is looking at: which action and version are selected, which tab
// is open, what the list is filtered by, and where the overflow menu sits.

import { useCallback, useEffect, useMemo, useState } from 'react';

import { currentVersion } from './atUtils';

export default function useActionsNavigation(actions) {
  const [selectedId, setSelectedId] = useState(null);
  const [selectedVersion, setSelectedVersion] = useState(1);
  const [tab, setTab] = useState('details');
  const [filter, setFilter] = useState({ search: '', categories: [] });
  const [menuPos, setMenuPos] = useState(null);

  const action = useMemo(
    () => actions.find((a) => a.id === selectedId) || null,
    [actions, selectedId],
  );

  // Falling back to the current version keeps the pane populated when the
  // selected number no longer exists — after a delete, for instance.
  const version = useMemo(() => {
    if (!action) return null;
    return (
      action.versions.find((v) => v.version === selectedVersion) ||
      currentVersion(action)
    );
  }, [action, selectedVersion]);

  const selectAction = useCallback(
    (id) => {
      setSelectedId(id);
      setTab('details');
      const chain = actions.find((x) => x.id === id);
      if (chain) setSelectedVersion(currentVersion(chain).version);
    },
    [actions],
  );

  // Land on the first action once the catalog arrives, unless the user already
  // picked one.
  useEffect(() => {
    if (actions.length === 0 || selectedId) return;
    setSelectedId(actions[0].id);
    setSelectedVersion(currentVersion(actions[0]).version);
  }, [actions, selectedId]);

  return {
    selectedId,
    setSelectedId,
    selectedVersion,
    setSelectedVersion,
    tab,
    setTab,
    filter,
    setFilter,
    menuPos,
    setMenuPos,
    action,
    version,
    selectAction,
  };
}
